import React, { useEffect } from 'react'
import { Redirect, useLocation } from 'react-router-dom'
import { Hub } from 'aws-amplify'
import { AuthState } from '@aws-amplify/ui-components'
import { AmplifyAuthenticator } from '@aws-amplify/ui-react'
import { toast } from 'react-toastify'
import colors from 'constants/colors'
import styled from 'styled-components'
import { Login } from 'components/auth/Login'
import { useSession } from './Session'

const LoginContainer = styled.div`
  padding-top: 5rem;
`

const AmplifyAuthenticatorStyled = styled(AmplifyAuthenticator)` 
  --amplify-primary-color: ${colors.primary};
  --amplify-primary-contrast: ${colors.white};
  --amplify-primary-tint: ${colors.primaryDark};
  --amplify-primary-shade: ${colors.primaryLight};
  --amplify-secondary-color: ${colors.black};
  --amplify-secondary-contrast: ${colors.inputGrey};
  --amplify-secondary-tint: ${colors.black};
  --amplify-secondary-shade: ${colors.black};
  --amplify-tertiary-color: ${colors.secondaryGreen};
  --amplify-tertiary-contrast: ${colors.secondaryGreen};
  --amplify-tertiary-tint: ${colors.secondaryGreen};
  --amplify-tertiary-shade: ${colors.secondaryGreen};
  --amplify-grey: ${colors.inputTextGrey};
  --amplify-light-grey: ${colors.inputTextGrey};
  --amplify-red: ${colors.error};
  --amplify-font-family: 'Poppins';
`

const AuthComponent = () => {
  const session = useSession()
  const location = useLocation()

  useEffect(() => {
    Hub.listen('auth', ({ payload: { event, data } }) => {
      if (event === 'signIn') {
        session.login(data)
      }
    })
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const isLogout = location.pathname.startsWith('/auth/logout')
  useEffect(() => {
    if (isLogout) {
      toast.success('You have been logged out.')
      session.logout()
    }
  }, [isLogout, session])

  if (isLogout) {
    return <Redirect to="/auth/login" />
  }

  if (session.user) {
    return <Redirect to="/" />
  }

  let initialAuthState = AuthState.SignIn
  if (location.pathname.startsWith('/auth/forgot')) {
    initialAuthState = AuthState.ForgotPassword
  }

  return (
    <LoginContainer>
      <AmplifyAuthenticatorStyled usernameAlias="email" initialAuthState={initialAuthState as any}>
        <div slot="sign-in">
          <Login />
        </div>
      </AmplifyAuthenticatorStyled>
    </LoginContainer>
  )
}

export default AuthComponent
